export default __webpack_public_path__ + "static/media/errorBackArrow.837e69f8.svg";